<template>
    <app-layout>
        <template #header>
            <div class="relative flex justify-between items-center">
                <div>
                    <h2 class=" font-bold text-xl leading-tight">
                        <i class="fas fa-hand-holding-usd"></i>
                        Enviar
                    </h2>
                </div>
                <balance :short="true" />
            </div>
        </template>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div class="xl:mt-22 lg:mt-20 md:mt-10 sm:mt-10 mt-8">
                <div class="inline-flex justify-center w-full">
                    <div class="w-full text-center">
                        <h4 class="font-medium text-center">
                            Selecione uma modalidade de envio
                        </h4>
                        <p class="mt-0 text-xs text-gray-500">
                            Dependendo da modalidade selecionada, nós o
                            direcionaremos para um processo mais rápido e
                            prático.
                        </p>
                    </div>
                </div>
                <div class="grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-4 xl:px-40 lg:px-30 md:px-10 px-8 mt-5">
                    <a
                        class="bg-white text-center inline-flex justify-center p-4 rounded cursor-pointer shadow-card"
                        :href="route('send', ['pix'])"
                    >
                        <div>
                            <div class="bg-yellow-300 w-12 h-12 rounded-full m-auto flex items-center justify-center">
                                <img class="w-4 h-4" src="../../../images/pix-icone.png" alt="" />
                            </div>
                            <h5 class="text-base my-2 font-medium">
                                Chave Pix
                            </h5>
                            <p class="text-xs text-gray-500">
                                Faça pagamentos com o máximo de praticidade.
                            </p>
                        </div>
                    </a>
                    <a
                        class="bg-white text-center inline-flex justify-center p-4 rounded shadow-card"
                        :href="route('send', ['ted'])"
                    >
                        <div>
                            <div class="bg-yellow-300 w-12 h-12 rounded-full m-auto flex items-center justify-center">
                                <i class="fas fa-exchange-alt"></i>
                            </div>
                            <h5 class="text-base my-2 font-medium">
                                Transferência TED
                            </h5>
                            <p class="text-xs text-gray-500">
                                Realize pagamentos para uma conta de outro
                                banco.
                            </p>
                        </div>
                    </a>
                    <a
                        class="bg-white text-center inline-flex justify-center p-4 rounded shadow-card"
                        :href="route('send', ['between-accounts'])"
                    >
                        <div>
                            <div class="bg-yellow-300 w-12 h-12 rounded-full m-auto flex items-center justify-center" >
                                <i class="fas fa-coins"></i>
                            </div>
                            <h5 class="text-base my-2 font-medium">
                                Entre contas {{ businessUnit.name ? businessUnit.name : '2GO BANK' }}
                            </h5>
                            <p class="text-xs text-gray-500">
                                Realize pagamentos para uma outra conta do mesmo
                                banco.
                            </p>
                        </div>
                    </a>
                    <a
                        class="bg-white text-center inline-flex justify-center p-4 rounded shadow-card"
                        :href="route('send', ['pix-copy-paste'])"
                    >
                        <div>
                            <div class="bg-yellow-300 w-12 h-12 rounded-full m-auto flex items-center justify-center">
                                <img class="w-4 h-4" src="../../../images/pix-icone.png" alt="icone pix" />
                            </div>
                            <h5 class="text-base my-2 font-medium">
                                Chave copia e cola
                            </h5>
                            <p class="text-xs text-gray-500">
                                Copie a chave copia e cola Pix e faça o
                                pagamento por ela.
                            </p>
                        </div>
                    </a>
                    <!-- desabilitado temporariamente -->
                    <div
                        v-if="false"
                        class="relative bg-white text-center inline-flex justify-center p-4 rounded shadow-card cursor-pointer"
                        @click.stop="showOptionsLots = !showOptionsLots"
                    >
                        <div>
                            <div class="bg-yellow-300 w-12 h-12 rounded-full m-auto flex items-center justify-center">
                                <i class="fas fa-list-ul"></i>
                            </div>
                            <h5 class="text-base my-2 font-medium">
                                Envio em lote
                            </h5>
                            <p class="text-xs text-gray-500">
                                Realize múltiplos pagamentos de uma vez.
                            </p>
                        </div>
                        <ul
                            v-if="showOptionsLots"
                            class="absolute rounded pt-2 pb-3 bg-white top-24 shadow w-full"
                            style="width: 116%"
                        >
                            <a :href="route('send.lots', ['pix'])">
                                <li class="flex items-center px-5 py-3 hover:bg-gray-50">
                                    <img class="w-4 h-4" src="../../../images/pix-icone.png" alt="icone pix" />
                                    <span class="ml-2 text-xs">Chave Pix</span>
                                </li>
                            </a>
                            <a :href="route('send.lots', ['ted'])">
                                <li class="flex items-center px-5 py-3 hover:bg-gray-50">
                                    <i class="fas fa-exchange-alt"></i>
                                    <span class="ml-2 text-xs">Transferência TED</span>
                                </li>
                            </a>
                            <a href="">
                                <li class="flex items-center px-5 py-3 hover:bg-gray-50">
                                    <img class="w-4 h-3" src="../../../images/Card/Logo cartao.png" alt="logo 2GO" />
                                    <span class="ml-2 text-xs">Entre contas 2GO</span>
                                </li>
                            </a>
                            <a href="">
                                <li class="flex items-center px-5 py-3 hover:bg-gray-50">
                                    <img class="w-4 h-4" src="../../../images/pix-icone.png" alt="icone pix" />
                                    <span class="ml-2 text-xs">Chave copia e cola Pix</span>
                                </li>
                            </a>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout.vue";
import Balance from "../../Helpers/Balance.vue";

export default {
    props: ['whiteLabel', 'businessUnit'],
    name: "Send",
    data: ()=> ({
        showOptionsLots: false
    }),
    components: {
        AppLayout,
        Balance
    }
};
</script>
